import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {booleanMetadata} from '../../../../../utils/builderMetadata'

export type DisplaySettingsParams = {
  showBreadcrumbs: SettingsParamType.Boolean
  showTitle: SettingsParamType.Boolean
  showLocationTabs: SettingsParamType.Boolean
  showExperienceImage: SettingsParamType.Boolean
  showExperienceSummary: SettingsParamType.Boolean
  showExperienceDuration: SettingsParamType.Boolean
  showExperienceDate: SettingsParamType.Boolean
  showExperiencePrice: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS: Record<keyof DisplaySettingsParams, any> = {
  showBreadcrumbs: true,
  showTitle: true,
  showLocationTabs: true,
  showExperienceImage: true,
  showExperienceSummary: true,
  showExperienceDuration: true,
  showExperienceDate: true,
  showExperiencePrice: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
      'Shows or hides the breadcrumbs above the experiences list',
    ),
  },
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showTitle,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showTitle,
      'Shows or hides the experiences list title',
    ),
  },
  showLocationTabs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showLocationTabs,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showLocationTabs,
      'Shows or hides the location tabs that filter experiences by location; the tabs appear only when experiences are in more than one location',
    ),
  },
  showExperienceImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceImage,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceImage,
      'Shows or hides the image on each experience card; images appear only when at least one experience has a cover image',
    ),
  },
  showExperienceSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceSummary,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceSummary,
      'Shows or hides the short summary on each experience card',
    ),
  },
  showExperienceDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDuration,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDuration,
      'Shows or hides the duration on each experience card',
    ),
  },
  showExperienceDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDate,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperienceDate,
      'Shows or hides the date on each experience card',
    ),
  },
  showExperiencePrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperiencePrice,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showExperiencePrice,
      'Shows or hides the price on each experience card',
    ),
  },
})
